import { basicEnum } from "./base";

export const MaintenanceTypeEnum = basicEnum([
    {
        label: "APP",
        value: "app",
    },
    {
        label: "API",
        value: "api",
    },
    {
        label: "DAEMON",
        value: "daemon",
    },
    {
        label: "RADIUS INTERNET AUTH",
        value: "radiusInternetAuth",
    },
    {
        label: "RADIUS INTERNET ACCT",
        value: "radiusInternetAcct",
    },
    {
        label: "RADIUS HOTSPOT AUTH",
        value: "radiusHotspotAuth",
    },
    {
        label: "RADIUS HOTSPOT Acct",
        value: "radiusHotspotAcct",
    },
    {
        label: "ONT ACS",
        value: "ontacs",
    },
]);

export namespace MaintenanceTypeEnum {
    export type Labels = (typeof MaintenanceTypeEnum)["labels"][number];
    export type Values = (typeof MaintenanceTypeEnum)["values"][number];
}
